/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteEmployeeModel as DigiworkMaitreDPosDtoEmployeeDeleteEmployeeModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Employee/delete-employee-model';

export interface DeleteEmployee$Params {
      body?: DigiworkMaitreDPosDtoEmployeeDeleteEmployeeModel
}

export function deleteEmployee(http: HttpClient, rootUrl: string, params?: DeleteEmployee$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteEmployee.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteEmployee.PATH = '/api/gmn/Employee/deleteemployee';
